import React from 'react';
import classNames from 'classnames';
import StatusDot from './Status/StatusDot';
import { emptyFormatter } from '../../utils/Formatters/ListFormatters';

const LabelValue = ({ label, value, horizontal, separator, useHorizontalRule, image, handleErrorImg, status, className, icon, emptySepar = false, addon = null, valueClasesName }) => {
  const classes = classNames('label-value', { horizontal, 'use-horizontal-rule': useHorizontalRule }, className);
  const finalValue = emptySepar ? emptyFormatter(value) : value;

  return (
    <div className={classes}>
      <div className="label-value-wrapper">
        <div className="label" id={`${label}-label`}>
          {label}
          {separator || null}
        </div>
        <div className={valueClasesName || 'value'} id={`${label}-value`}>
          {finalValue}
        </div>
      </div>
      <div className="label-value-image">{image ? <img src={image} alt="" onError={handleErrorImg} id={`${label}-image-value`} /> : null}</div>
      <div className="label-value-status">{status ? <StatusDot status={status} /> : null}</div>
      <div className="label-value-icon-action">{icon || null}</div>
      {addon && <div className="label-value__addon">{addon}</div>}
    </div>
  );
};

export default LabelValue;
